import { ApiClient } from '@k2/common/backend/api-client';
import { map } from 'rxjs/operators';

export class SearchEndpoint {
  constructor(private http: ApiClient) {}

  query = (query: string) => {
    return this.http
      .get(`/search/${encodeURIComponent(query)}`)
      .pipe(map(payload => payload.results));
  };

  searchAssignmentLinks = (query: string, params: { [name: string]: string }) => {
    let url = `/search/assignment-links/${encodeURIComponent(query)}`;
    for (const key in params) {
      url += '/' + key + '/' + params[key] ;
    }
    return this.http
      .get(url)
      .pipe(map(payload => payload.results));
  };

  searchAirports = (query: string) => {
    return this.http
      .get(`/search/airport/${encodeURIComponent(query)}`)
      .pipe(map(payload => payload.results.data));
  };
}
